import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import LexiconEntry from './LexiconEntry';
import LexiconSearch from './LexiconSearch';
import LexiconSearcher from '../new/lexicons/LexiconSearcher';
import LexiconStore from '../new/lexicons/LexiconStore';
import PropTypes from 'prop-types';
import WordPosition from '../new/lexicons/WordPosition';
import './LexiconView.css';

export default class LexiconView extends Component {

    static contextTypes = {
        lexicons: PropTypes.instanceOf(LexiconStore).isRequired
    }

    static propTypes = {
        verseIndex: PropTypes.number,
        sourceIndex: PropTypes.number,
        wordIndex: PropTypes.number,
        partIndex: PropTypes.number
    }

    constructor(props, context) {
        super(props);
        this.state = {
            entries: null,
            searching: false
        }
        this.lexiconSearcher = new LexiconSearcher(context.lexicons);
        this.onStemSearched = this.onStemSearched.bind(this);
        this.onStemSelect = this.onStemSelect.bind(this);
        this.searchEntries = this.searchEntries.bind(this);
        this.getWordPosition = this.getWordPosition.bind(this);
    }

    onStemSearched(stem) {
        this.searchEntries(stem, false);
    }

    onStemSelect(stem) {
        this.searchEntries(stem, true);
    }

    searchEntries(stem, strict) {
        this.setState({ searching: true });
        this.lexiconSearcher.searchEntries(stem.getText(), stem.getLanguage(), strict)
            .then(entries => this.setState({ entries, searching: false }))
            .catch(error => console.log(error));
    }

    getWordPosition() {
        const { verseIndex, sourceIndex, wordIndex, partIndex } = this.props;
        if (typeof verseIndex === 'number' && typeof sourceIndex === 'number' &&
                typeof wordIndex === 'number' && typeof partIndex === 'number') {
            return new WordPosition(verseIndex, sourceIndex, wordIndex, partIndex);
        } else {
            return undefined;
        }
    }

    render() {
        const entries = this.state.entries;
        var content;
        if (this.state.searching) {
            content = <CircularProgress className="LexiconView_Loading" color="secondary" />;
        } else if (!entries) {
            content = <div className="LexiconView_Empty" />;
        } else if (entries.getMatchCount() === 0) {
            content = <div className="LexiconView_Empty">No entries</div>;
        } else {
            content = entries.getMatches().map((match, index) =>
                <LexiconEntry key={index} match={match} />);
        }
        return (
            <div className="LexiconView">
                <LexiconSearch
                    searcher={this.lexiconSearcher}
                    wordPosition={this.getWordPosition()}
                    onStemSearched={this.onStemSearched}
                    onStemSelect={this.onStemSelect} />
                <div className="LexiconView_Content">{content}</div>
            </div>
        );
    }
}
